import React from 'react'
import { Tabs } from '@mantine/core'

const TransparenciaTab = ({ value, abaAtiva, children }) => {
    return (
        <Tabs.Tab
            fz={'md'}
            value={value}
            color="green"
            style={{
                color: '#295661',
                fontWeight: abaAtiva === value ? 600 : 400
            }}
        >
            {children}
        </Tabs.Tab>
    )
}

export default TransparenciaTab
